<div class="card">
  @if (_resetPasswordForm) {
    <form novalidate [formGroup]="_resetPasswordForm" (ngSubmit)="onResetPassword()" class="form-horizontal" #resetPasswordFormChild="ngForm">
      <input type="hidden" autocomplete="false" />
      <header class="card-header card-default">
        <h2 class="card-title">
          <i class="material-icons m-r-10">vpn_key</i>
          {{ 'Modules.Users.Applications.Users.ResetPassword.Title' | translate }}
        </h2>
      </header>
      <div class="card-block pt-3">
        <div class="media">
          <mat-icon class="mr-3 align-self-center mat-icon material-icons">info_outline</mat-icon>
          <div class="media-body">
            <small>{{ 'Commons.Validation.Password' | translate }}</small>
          </div>
        </div>
        <mat-form-field class="mt-4">
          <mat-label for="password">{{ 'Modules.Users.Applications.Users.ResetPassword.Form.NewPassword' | translate }}:</mat-label>
          <input type="password" name="newPassword" matInput formControlName="newPassword" required autocomplete="new-password" />
          @if (newPassword.errors?.required && newPassword.touched) {
            <mat-error>
              {{'Commons.Validation.Required' | translate : { field: "Modules.Users.Applications.Users.ResetPassword.Form.NewPassword" | translate } }}
            </mat-error>
          }
          @if (newPassword.errors?.pattern && newPassword.touched) {
            <mat-error>
              {{ 'Commons.Validation.Pattern' | translate }}
            </mat-error>
          }
        </mat-form-field>
        <mat-form-field>
          <mat-label for="confirmNewPassword">{{ 'Modules.Users.Applications.Users.ResetPassword.Form.ConfirmPassword' | translate }}:</mat-label>
          <input type="password" name="confirmNewPassword" matInput formControlName="confirmNewPassword" required autocomplete="new-password" />
          @if ((confirmNewPassword.errors?.required || confirmNewPassword.errors?.equalTo) && confirmNewPassword.touched) {
            <mat-error>
              {{ 'Commons.Validation.Compare' | translate: { field1: "Modules.Users.Applications.Users.ResetPassword.Form.NewPassword" | translate, field2: "Modules.Users.Applications.Users.ResetPassword.Form.ConfirmPassword" | translate } }}
            </mat-error>
          }
          @if (confirmNewPassword.errors?.pattern && confirmNewPassword.touched) {
            <mat-error>
              {{ 'Commons.Validation.Pattern' | translate }}
            </mat-error>
          }
        </mat-form-field>
      </div>
      <div class="card-footer">
        <button type="submit" mat-flat-button mat-ripple color="accent" [class.disabled]="!_resetPasswordForm.valid">
          <i class="material-icons m-r-10">check</i>
          {{ 'Commons.Actions.Confirm' | translate }}
        </button>
      </div>
    </form>
  }
</div>